import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Squab from "@/pages/Squab";
import Play from "@/pages/Play";
import Leaderboard from "@/pages/Leaderboard";
import Achievements from "@/pages/Achievements";
import Profile from "@/pages/Profile";
import Premium from "@/pages/Premium";
import PaymentResult from "@/pages/PaymentResult";
import Community from "@/pages/Community";
import Admin from "@/pages/Admin";
import Archive from "@/pages/Archive";
import About from "@/pages/About";
import HowToPlay from "@/pages/HowToPlay";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Google OAuth returns to {redirect}#session_id=... — detect it reactively on ANY route
  // and process it BEFORE protected routes run. Must read location.hash (reactive), not window.location.hash.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/squab/:challengeId" element={<Squab />} />
      <Route path="/play/:zone" element={<Play />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/achievements" element={<Achievements />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/premium" element={<Premium />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/community" element={<Community />} />
      <Route path="/archive" element={<Archive />} />
      <Route path="/about" element={<About />} />
      <Route path="/how-to-play" element={<HowToPlay />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
